import React, { ImgHTMLAttributes, useEffect, useRef } from 'react';

export const IMAGE_CACHE_NAME = 'image-cache-v2';
async function cacheImage(url: string) {
  if (typeof caches === 'undefined') {
    return;
  }

  const cacheKey = url.split('?')[0];
  const cache = await caches.open(IMAGE_CACHE_NAME);
  const response = await fetch(url);

  await cache.put(cacheKey, response);
}

async function getCachedImage(url: string) {
  if (typeof caches === 'undefined') {
    return;
  }

  const cacheKey = url.split('?')[0];
  const cache = await caches.open(IMAGE_CACHE_NAME);
  const response = await cache.match(cacheKey);

  return response ? URL.createObjectURL(await response.blob()) : null;
}

export default function CachedImage({ src, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!src) return;

    getCachedImage(src).then(cachedImageURL => {
      if (!imageRef.current) return;

      if (cachedImageURL) {
        imageRef.current.src = cachedImageURL;
      } else {
        imageRef.current.src = src;
        cacheImage(src);
      }
    });
  }, [src]);

  if (typeof caches === 'undefined') {
    // eslint-disable-next-line jsx-a11y/alt-text
    return <img ref={imageRef} src={src} {...props} />;
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img ref={imageRef} {...props} />;
}
